export enum Layout {
  Default = "default",
  Embeddable = "embeddable",
}
